import { SagaIterator } from 'redux-saga'
import { all, AllEffect } from 'redux-saga/effects'

import * as app from './modules/app'
import * as account from './modules/account'
import * as users from './modules/users'
import * as notifications from './modules/notifications'
import * as assistant from './modules/assistant'
import * as presence from './modules/presence'

export default function* root(): TRootSaga {
  yield all([
    app.sagas(),
    account.sagas(),
    users.sagas(),
    notifications.sagas(),
    assistant.sagas(),
    presence.sagas(),
  ])
}

export type TRootSaga = Generator<AllEffect<SagaIterator>, void, unknown>
